<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 背景装饰圆点 -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute top-20 left-20 w-8 h-8 bg-psychology-primary/10 rounded-full"></div>
      <div class="absolute top-40 right-32 w-12 h-12 bg-psychology-accent/10 rounded-full"></div>
      <div class="absolute bottom-40 left-1/4 w-6 h-6 bg-psychology-secondary/10 rounded-full"></div>
      <div class="absolute bottom-32 right-20 w-10 h-10 bg-psychology-primary/5 rounded-full"></div>
    </div>

    <div class="relative z-10">
      <!-- 导航栏 -->
      <NavBar />

      <!-- 主要内容 -->
      <main class="container mx-auto px-4 pb-20">
        <!-- Hero区域 -->
        <HeroSection />

        <!-- 测评视角选择 -->
        <TestTypeSection />

        <!-- 四大维度 -->
        <DimensionsSection />

        <!-- 隐私保护 -->
        <PrivacySection />

        <!-- CTA区域 -->
        <CTASection />
      </main>

      <!-- 页脚 -->
      <FooterSection />
    </div>

    <!-- 回到顶部按钮 -->
    <BackToTop />
  </div>
</template>

<script>
import NavBar from './NavBar.vue'
import HeroSection from './HeroSection.vue'
import TestTypeSection from './TestTypeSection.vue'
import DimensionsSection from './DimensionsSection.vue'
import PrivacySection from './PrivacySection.vue'
import CTASection from './CTASection.vue'
import FooterSection from './Footer.vue'
import BackToTop from './BackToTop.vue'

export default {
  name: 'HomePage',
  components: {
    NavBar,
    HeroSection,
    TestTypeSection,
    DimensionsSection,
    PrivacySection,
    CTASection,
    FooterSection,
    BackToTop
  }
}
</script>

